module.exports = __webpack_public_path__ + "static/media/community-builder-4.a3a6717b.jpg";